import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useForm, Controller } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Skeleton } from "primereact/skeleton";

import CountryDropdown from "../../countryDropDown";

const AddressFileds = ({ data, handleOnchange, isEdit, isLoading }) => {
  const {
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
    defaultValues: data,
  });

  useEffect(() => {
    const safeData = data || {};
    reset(safeData);
  }, [data, reset]);

  return (
    <>
      <div className="field input-item col-6 ">
        <label className="input-label">Country *</label>
        {isLoading ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="country"
            control={control}
            rules={{
              required: "Country is required.",
            }}
            render={({ field }) => (
              <CountryDropdown
                {...field}
                value={data?.country}
                name="country"
                disabled={!isEdit}
                onChange={(e) => {
                  field.onChange(e.value);
                  handleOnchange(e, data.id);
                }}
                className={`w-full ${!isEdit && "dropdown-field"} ${!isEdit && "disable"} ${
                  errors.country ? "p-invalid" : ""
                }`}
              />
            )}
          />
        )}
        {errors?.country && (
          <small className="p-error">{errors?.country?.message}</small>
        )}
      </div>
      <div className="field input-item col-12">
        <label className="input-label">Address Line 1 *</label>
        {isLoading ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="address_line_1"
            control={control}
            rules={{
              required: "Address is required.",
            }}
            render={({ field }) => (
              <InputText
                {...field}
                onChange={(e) => {
                  field.onChange(e);
                  handleOnchange(e, data.id);
                }}
                value={data?.address_line_1 || ""}
                type="text"
                disabled={!isEdit}
                placeholder="Enter Street Address"
                className={`input-field appearance-none outline-none w-full ${!isEdit && "disable"} ${
                  errors?.address_line_1 ? "error" : ""
                }`}
              />
            )}
          />
        )}
        {errors?.address_line_1 && (
          <small className="p-error">{errors?.address_line_1?.message}</small>
        )}
      </div>

      <div className="field input-item col-12">
        <label className="input-label">Address Line 2</label>
        {isLoading ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="address_line_2"
            control={control}
            render={({ field }) => (
              <InputText
                {...field}
                onChange={(e) => {
                  field.onChange(e);
                  handleOnchange(e, data.id);
                }}
                disabled={!isEdit}
                value={data?.address_line_2 || ""}
                type="text"
                placeholder="Apartment, Suit, or Building Number(optional)"
                className={`input-field appearance-none outline-none w-full ${!isEdit && "disable"}`}
              />
            )}
          />
        )}
      </div>

      <div className="field input-item col-12 md:col-6">
        <label className="input-label">State / Province</label>
        {isLoading || data?.stateLoader ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="state"
            control={control}
            render={({ field }) => (
              <Dropdown
                {...field}
                value={data?.state || ""}
                onChange={(e) => {
                  field.onChange(e.value);
                  handleOnchange(e, data.id);
                }}
                disabled={!isEdit}
                options={data?.stateOptions || []}
                optionLabel="name"
                placeholder={"Select State or Province"}
                checkmark={true}
                highlightOnSelect={false}
                className={`appearance-none outline-none w-full ${!isEdit && "dropdown-field"} ${!isEdit && "disable"} `}
              />
            )}
          />
        )}
      </div>
      <div className="field input-item col-12 md:col-6">
        <label className="input-label">City</label>
        {isLoading || data?.cityLoader ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="city"
            control={control}
            render={({ field }) => (
              <Dropdown
                value={data?.city || ""}
                onChange={(e) => {
                  handleOnchange(e, data.id);
                  field.onChange(e);
                }}
                disabled={!isEdit}
                options={data?.cityOptions || []}
                optionLabel="name"
                placeholder={"Select City"}
                checkmark={true}
                highlightOnSelect={false}
                name="city"
                className={`appearance-none outline-none w-full ${!isEdit && "dropdown-field"} ${!isEdit && "disable"} `}
              />
            )}
          />
        )}
      </div>
      <div className="field input-item col-6">
        <label className="input-label">Postal Code / Zip Code *</label>
        {isLoading ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="postalcode"
            control={control}
            rules={{
              required: "Postal code is required.",
              pattern: {
                value: /^(?!\s*$)[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/,
                message: "Postal code must be numbers",
              },
            }}
            render={({ field }) => (
              <InputText
                {...field}
                onChange={(e) => {
                  handleOnchange(e, data.id);
                  field.onChange(e);
                }}
                disabled={!isEdit}
                value={data?.postalcode || ""}
                type="text"
                placeholder="Postal Code or ZIP Code"
                className={`input-field appearance-none outline-none w-full ${!isEdit && "disable"} ${
                  errors?.postalcode ? "p-invalid" : ""
                }`}
              />
            )}
          />
        )}

        {errors?.postalcode && (
          <small className="p-error">{errors?.postalcode.message}</small>
        )}
      </div>
      <div className="field input-item col-6"></div>
    </>
  );
};

AddressFileds.propTypes = {
  handleOnchange: PropTypes.func,
  data: PropTypes.object,
};
export default AddressFileds;
